<template>
  <typeahead-input
    v-model="inputValue"
    :input-label="inputLabel"
    :placeholder="placeholder"
    :input-id="inputId"
    :typeahead="typeaheadFunction"
    :typeahead-item-key="typeaheadItemKey"
    :typeahead-limit="typeaheadLimit"
    :show-typeahead-details="showTypeaheadDetails"
    :form="form"
    :errors="errors"
    :disabled="disabled"
    @typeahead-selected="$emit('typeahead-selected', $event)"
    @change="$emit('change', $event)"
  >
  </typeahead-input>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import TypeaheadInput from '@/common/components/TypeaheadInput.vue'
import { OrganizationSubjects } from '@/enums/OrganizationSubjects';
import { DaDataDistricts } from '@/common/enums/DaDataDistricts';
import { DaData } from '@/common/helpers/api-client/DaData';

export default {
  name: 'OrganizationNameInput',

  components: {
    TypeaheadInput
  },

  mixins: [
    applicationInputMixin
  ],

  props: {
    inputLabel: {
      type: String,
      default: 'Наименование организации'
    },
    placeholder: {
      type: String,
      default: 'Введите наименование или ИНН организации'
    },
    inputId: {
      type: String,
      default: 'form-organization-name'
    },

    // Typeahead props
    typeahead: {
      type: Function,
      default: null
    },
    typeaheadData: {
      type: Array,
      default: () => []
    },
    typeaheadItemKey: {
      type: String,
      default: 'short_name'
    },
    typeaheadLimit: {
      type: Number,
      default: 5
    },
    selectTypeahead: {
      type: Function,
      default: () => {
      }
    },

    // Error display props
    showInnError: {
      type: Boolean,
      default: false
    },
    innErrorText: {
      type: String,
      default: ''
    },

    // Hint props
    showHint: {
      type: Boolean,
      default: false
    },
    hintText: {
      type: String,
      default: 'Наименование организации, от имени которой подается заявка'
    },

    // Region checkbox props
    showRegionCheckbox: {
      type: Boolean,
      default: false
    },
    checkboxValue: {
      type: String,
      default: 'nw'
    },
    checkboxLabel: {
      type: String,
      default: 'Искать только в Северо-Западном ФО'
    },
    checkboxId: {
      type: String,
      default: 'checkbox'
    },

    // Typeahead details display
    showTypeaheadDetails: {
      type: Boolean,
      default: true
    },

    // Form context
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },

    // Additional props
    disabled: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },

    // Events
    switchLocationName: {
      type: Function,
      default: () => {
      }
    },

    subjectId: {
      type: String,
      default: 'entity'
    },
    nationalityId: {
      type: Number,
      default: 182
    }
  },
  methods: {
    async typeaheadFunction(query, done) {
      if (this.nationalityId === 182) {
        done(await this.getOrganizationSuggestions(query, true, false, this.subjectId))
      }
      if (this.nationalityId === 113) {
        done(await this.getKzOrganizationSuggestions(query, true, false, this.subjectId))
      }
      if (this.nationalityId === 20) {
        done(await this.getBelorusOrganizationSuggestions(query, true, false, this.subjectId))
      }
    },

    async getOrganizationSuggestions(query, _, inn) {
      let type = 'LEGAL'
      if (this.subjectId === OrganizationSubjects.Individual) {
        type = 'INDIVIDUAL'
      }

      const organizationsRequest = await DaData.suggestParty(query, {
        type,
        locations: DaDataDistricts.RUS.all,
        residency: 'RU'
      })

      if (!organizationsRequest.suggestions || !Array.isArray(organizationsRequest.suggestions)) {
        return
      }

      return organizationsRequest.suggestions.map(item => {
        if (inn) {
          item.value = item.data ? item.data.inn : null
        }

        return item
      })
    }
  }
}
</script>
